import { BiHappyHeartEyes } from "react-icons/bi";
import { FaAward } from "react-icons/fa6";
import { TbBooks } from "react-icons/tb";

const data = [
  { id: 1, icon: <FaAward />, title: "Experience", desc: "2+ Years Working" },
  { id: 2, icon: <TbBooks />, title: "Projects", desc: "30+ Completed" },
  {
    id: 3,
    icon: <BiHappyHeartEyes />,
    title: "Clients",
    desc: "10+ Happy Clients",
  },
];

export default data;
